import styled from "@emotion/styled";
export const StyledMobileTemplatesNavigation = styled.div`
  width: 100%;

  .mobile-search-wrapper {
    margin-top: 8px;
  }
`;
